export const scheduleTypes = {
    time: "Time",
    situation: "Situation",
    paramValue: "ParamValue",
};
